const locationsHash: { [index: string] : string | undefined } = {
  "/popular": "popular",
  "/upvoted": "upvoted",
  "/discussed": "discussed",
  "/recent": "recent",
  "/myVotes": "myVotes",
}

export default locationsHash;
